import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query'
import { QueryKeys } from '~/services/queryClient'
import { deleteSession, getSessions, Session } from '~/services/userService'

export function useSessions(): UseQueryResult<Session[]> {
  return useQuery({
    queryKey: [QueryKeys.Sessions],
    queryFn: getSessions,
    select(data) {
      return data.sessions
    }
  })
}

export function useDeleteSession() {
  const { mutateAsync: deleteSessionMutation } = useMutation({
    mutationFn: deleteSession
  })

  return (deviceName: string) => deleteSessionMutation(deviceName)
}
